import React from "react";

interface DocDataGridSavingContextValue {
  isSavingRow: (rowId: string) => boolean;
}

export const DocDataGridSavingContext =
  React.createContext<DocDataGridSavingContextValue>({
    isSavingRow: () => false,
  });
